/**
 * Generate a normalized cart key for Firestore document IDs
 * Ensures consistent, safe document IDs by:
 * - Lowercasing all characters
 * - Removing special characters that could cause issues
 * - Using underscore separator for readability
 */
export const cartKey = ({ productId, variationId }: { productId: string; variationId?: string }): string => {
  // Normalize productId: lowercase and remove invalid chars
  const normalizedProductId = productId.toLowerCase().replace(/[^a-z0-9-_]/g, '');
  
  // Normalize variationId: use 'simple' if not provided, otherwise sanitize
  const normalizedVariationId = variationId 
    ? variationId.toString().toLowerCase().replace(/[^a-z0-9-_]/g, '')
    : 'simple';
  
  // Return key with underscore separator (Firestore-safe)
  return normalizedVariationId !== 'simple' 
    ? `${normalizedProductId}__${normalizedVariationId}`
    : normalizedProductId;
};


